// store/modules/training.js

import {secureStorage} from "@/services/secureStorage";

export default {
    namespaced: true,
    state: () => ({
        trainingRounds: secureStorage.getItem('trainingRounds') || [],
        trainingRoundsIdToView: JSON.parse(secureStorage.getItem('trainingRoundsIdToView')) || null,
        trainingRoundsIdToCreate: JSON.parse(secureStorage.getItem('trainingRoundsIdToCreate')) || null,
        trainingRoundsIdToEdit: JSON.parse(secureStorage.getItem('trainingRoundsIdToEdit')) || null,

    }),
    mutations: {
        setMutTrainingRounds(state, rounds) {
            state.trainingRounds = rounds;
            secureStorage.setItem('trainingRounds', rounds);
        },
        updateMutTrainingRounds(state, updatedRound) {
            if (!updatedRound || !updatedRound.id) return;
            const index = state.trainingRounds.findIndex(u => u.id === updatedRound.id);
            if (index !== -1) {
                state.trainingRounds[index] = { ...state.trainingRounds[index], ...updatedRound };
            } else {
                state.trainingRounds.push(updatedRound);
            }
            secureStorage.setItem('trainingRounds', state.trainingRounds);

        },
        resetTrainingRounds(state) {
            state.trainingRounds = [];
            secureStorage.removeItem('trainingRounds');
        },
        setMutTrainingRoundsIdToView(state, id) {
            state.trainingRoundsIdToView = id;
            secureStorage.setItem('trainingRoundsIdToView', id);
        },
        resetTrainingRoundsIdToView(state) {
            state.trainingRoundsIdToView = null;
            secureStorage.removeItem('trainingRoundsIdToView');
        },
        setMutTrainingRoundsIdToCreate(state, payload) {
            state.trainingRoundsIdToCreate = payload;
            secureStorage.setItem('trainingRoundsIdToCreate', JSON.stringify(payload));
        },
        resetTrainingRoundsIdToCreate(state) {
            state.trainingRoundsIdToCreate = null;
            secureStorage.removeItem('trainingRoundsIdToCreate');
        },
        setMutTrainingRoundsIdToEdit(state, payload) {
            state.trainingRoundsIdToEdit = payload;
            secureStorage.setItem('trainingRoundsIdToEdit', JSON.stringify(payload));
        },
        resetTrainingRoundsIdToEdit(state) {
            state.trainingRoundsIdToEdit = null;
            secureStorage.removeItem('trainingRoundsIdToEdit');
        },

    },
    actions: {
        setTrainingRounds({ commit }, rounds) {
            commit('setMutTrainingRounds', rounds);
        },
        updateTrainingRounds({ commit }, updatedRound) {
            console.log('🧪 Recibido para actualizar:', updatedRound);
            commit('updateMutTrainingRounds', updatedRound);
        },
        clearTrainingRounds({ commit }) {
            commit('resetTrainingRounds');
        },
        setTrainingRoundsIdToView(context, id) {
            context.commit('setMutTrainingRoundsIdToView', id);
        },
        clearTrainingRoundsIdToView({ commit }) {
            commit('resetTrainingRoundsIdToView');
        },
        setTrainingRoundsIdToCreate({ commit }, payload) {
            commit('setMutTrainingRoundsIdToCreate', payload);
        },
        clearTrainingRoundsIdToCreate({ commit }) {
            commit('resetTrainingRoundsIdToCreate');
        },
        setTrainingRoundsIdToEdit(context, id) {
            context.commit('setMutTrainingRoundsIdToEdit', id);
        },
        clearTrainingRoundsIdToEdit({ commit }) {
            commit('resetTrainingRoundsIdToEdit');
        },

    },
    getters: {
        getTrainingRounds: state => state.trainingRounds,
        getTrainingRoundsById: state => id =>
            state.trainingRounds.find(u => u.id === id)
    }
};